/**
 * CJSUSPENSION model-page Air Volume Spacer placement.
 *
 * Air Volume Spacer Setup is maintained through the shared
 * fork/rear-shock master service blocks, but is presented to customers
 * as a performance upgrade rather than a repair/tuning card.
 */
(function () {
  'use strict';

  function normalise(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isAirVolumeSpacerCard(card) {
    var heading = card && card.querySelector ? card.querySelector('h3') : null;
    return normalise(heading ? heading.textContent : '').indexOf('air volume spacer setup') !== -1;
  }

  function findUpgradeGrid() {
    var grids = document.querySelectorAll('.cjs-model-upgrade-grid');
    return grids.length ? grids[0] : null;
  }

  function findAirShaftCard(grid) {
    var cards = grid ? grid.querySelectorAll('.cjs-model-upgrade-card') : [];

    for (var i = 0; i < cards.length; i += 1) {
      var heading = cards[i].querySelector('h3');
      var title = normalise(heading ? heading.textContent : '');

      if (title.indexOf('air shaft travel change') !== -1) {
        return cards[i];
      }
    }

    return null;
  }

  function convertCardToUpgrade(card) {
    card.classList.remove('cjs-model-card');
    card.classList.add('cjs-model-upgrade-card');

    var buttons = Array.prototype.slice.call(card.querySelectorAll('a.cjs-model-button'));
    if (!buttons.length) {
      return;
    }

    var actions = card.querySelector('.cjs-model-upgrade-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'cjs-model-upgrade-actions';
      card.appendChild(actions);
    }

    buttons.forEach(function (button) {
      button.classList.add('secondary');
      actions.appendChild(button);
    });
  }

  function moveAirVolumeSpacerCards() {
    var upgradeGrid = findUpgradeGrid();
    if (!upgradeGrid) {
      return;
    }

    var sourceCards = Array.prototype.slice.call(document.querySelectorAll('.cjs-model-card')).filter(isAirVolumeSpacerCard);
    if (!sourceCards.length) {
      return;
    }

    sourceCards.forEach(function (card) {
      convertCardToUpgrade(card);

      var airShaftCard = findAirShaftCard(upgradeGrid);
      if (airShaftCard && airShaftCard.parentNode === upgradeGrid) {
        airShaftCard.insertAdjacentElement('afterend', card);
      } else {
        upgradeGrid.insertBefore(card, upgradeGrid.firstChild);
      }
    });
  }

  function run() {
    if (!document.querySelector('.cjs-model-service')) {
      return;
    }

    moveAirVolumeSpacerCards();

    window.setTimeout(moveAirVolumeSpacerCards, 80);
    window.setTimeout(moveAirVolumeSpacerCards, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
